import React, { useEffect, useState } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import LoadingOverlay from '../../components/LoadingOverlay';
import { legalApi, legalApiLang } from '../../api/legal';

const Imprint = () => {
  const { i18n } = useTranslation();
  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setHtml(null);
    setError(null);
    const lang = legalApiLang(i18n.language);
    legalApi
      .getImprintHtml(lang)
      .then((text) => {
        if (!cancelled) setHtml(text);
      })
      .catch(() => {
        if (!cancelled) setError('Could not load imprint.');
      });
    return () => {
      cancelled = true;
    };
  }, [i18n.language]);

  if (error) {
    return (
      <div className='imprint-holder'>
        <p>{error}</p>
      </div>
    );
  }
  if (html === null) {
    return <LoadingOverlay />;
  }
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Imprint;
